import Navbar from "./components/Navbar";
import About from "./components/About";

export default function App() {
  return (
    <main className="text-[#05386B] bg-[#fdfffa] body-font">
      <Navbar />
      <About />
    </main>
  );
}
